import { render, staticRenderFns } from "./twoInOne.vue?vue&type=template&id=0a50696f&"
import script from "./twoInOne.vue?vue&type=script&lang=js&"
export * from "./twoInOne.vue?vue&type=script&lang=js&"
import style0 from "./twoInOne.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\笑笑\\Desktop\\pay-pos-spa\\pay-pos-spa\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a50696f')) {
      api.createRecord('0a50696f', component.options)
    } else {
      api.reload('0a50696f', component.options)
    }
    module.hot.accept("./twoInOne.vue?vue&type=template&id=0a50696f&", function () {
      api.rerender('0a50696f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/twoInOne/twoInOne.vue"
export default component.exports